
import { useCallback, useEffect, useState } from "react";
import Particles from "react-particles";
import type { Engine } from "tsparticles-engine";
import { loadFull } from "tsparticles";

interface ParticlesBackgroundProps {
  className?: string;
  fullScreen?: boolean;
}

export const ParticlesBackground = ({ className, fullScreen = false }: ParticlesBackgroundProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const particlesInit = useCallback(async (engine: Engine) => {
    await loadFull(engine);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <Particles
      className={className || "fixed inset-0 z-0"}
      id="tsparticles"
      init={particlesInit}
      options={{
        fullScreen: fullScreen,
        background: {
          color: {
            value: "transparent",
          },
        },
        fpsLimit: 60,
        particles: {
          color: {
            value: "#f0b90b", // Yellow color to match the Bizlytics theme
          },
          links: {
            color: "#f0b90b",
            distance: 150,
            enable: true,
            opacity: 0.4, // Reduced opacity for subtlety
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outModes: {
              default: "bounce",
            },
            random: false,
            speed: 0.8, // Reduced speed
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 800,
            },
            value: 50, // Reduced quantity
          },
          opacity: {
            value: 0.5, // Slightly reduced
          },
          shape: {
            type: "circle",
          },
          size: {
            value: { min: 1, max: 4 }, // Slightly reduced max size
          },
        },
        detectRetina: true,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            push: {
              quantity: 2, // Reduced from 3
            },
            repulse: {
              distance: 100,
              duration: 0.4,
            },
          },
        },
      }}
    />
  );
};
